import {Button} from '@mantine/core';
import React from 'react';

import {assert} from 'Asserts';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {JSONValue} from 'util/Types';

import {useStepConfigEditorContext} from '../StepConfigEditorContext';

export interface TableReferenceEditorProps {
  config: Array<Record<string, JSONValue>>;
  disabledColumns?: Array<string>;
  hiddenColumns?: Array<string>;
  onChangeConfig: (config: Array<Record<string, JSONValue>>) => void;
  configShape: GetPipelineConfigSpecType<'tableReference'>;
  dataTestAttrs?: DataTestAttrs;
  disabled?: boolean;
}

export default function TableReferenceEditor({
  config,
  onChangeConfig,
}: TableReferenceEditorProps): JSX.Element {
  const {dataFrameId} = useStepConfigEditorContext();
  assert(dataFrameId != null, 'Using TableReferenceEditor in context without access to persisted data frame');

  return (
    <div>
      {/* TODO(BNCH-129724): Implement editable table component. Empty callback button for now to unblock testing. */}
      <Button
        variant="gradient"
        gradient={{from: '#ed6ea0', to: '#ec8c69', deg: 35}}
        onClick={() => {
          onChangeConfig(config);
        }}
      >
        Trigger callback
      </Button>
    </div>
  );
}
